import { Mid } from "src/app/constants/mids";

export const BrandImgConstants: Record<any, string> = {
  [Mid.USA_DV]: "/assets/img/brand_logos/usa_dv_logo.png",
  [Mid.CMG]: "/assets/img/brand_logos/cmg_logo.webp",
  [Mid.VDC]: "/assets/img/brand_logos/vdc_logo.png",
  [Mid.BCN]: "/assets/img/brand_logos/bcn_logo.png",
  [Mid.MDC]: "/assets/img/brand_logos/mdc_logo.png",
  [Mid.CV]: "/assets/img/brand_logos/cv_logo.svg",
  [Mid.ACX]: "/assets/img/brand_logos/acx_logo.png",
  [Mid.BCN_MDC]: "/assets/img/brand_logos/mdc_logo.png",
  [Mid.AUMG]: "/assets/img/brand_logos/aumg_logo.png",
};

export const BrandImgShortConstants: Record<any, string> = {
  [Mid.USA_DV]: "/assets/img/brand_logos/usa_dv_logo_short.png",
  [Mid.CMG]: "/assets/img/brand_logos/cmg_logo_short.png",
  [Mid.VDC]: "/assets/img/brand_logos/vdc_logo_short.png",
  [Mid.BCN]: "/assets/img/brand_logos/bcn_logo_short.ico",
  [Mid.MDC]: "/assets/img/brand_logos/mdc_logo_short.png",
  [Mid.CV]: "/assets/img/brand_logos/cv_logo_short.png",
  [Mid.ACX]: "/assets/img/brand_logos/acx_logo_short.png",
  [Mid.BCN_MDC]: "/assets/img/brand_logos/bcn_mdc_logo_short.png",
  [Mid.AUMG]: "/assets/img/brand_logos/aumg_logo_short.png"
};
